import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IBulkChangeTrackerCountryPayload } from '../types';
import {
  AFFILIATE_MASS_CHANGE_TRACKER_COUNTRY_API_URL,
  AFFILIATE_MASS_CHANGE_TRACKER_COUNTRY_MUTATION,
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '../constants';

export default function useBulkChangeTrackerCountryMutation(): IContextMutationResult<void, Error, IBulkChangeTrackerCountryPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IBulkChangeTrackerCountryPayload>({
    mutationKey: [AFFILIATE_MASS_CHANGE_TRACKER_COUNTRY_MUTATION],
    mutationFn: ({ id, ...payload }) => fetchPost<void>(
      AFFILIATE_MASS_CHANGE_TRACKER_COUNTRY_API_URL,
      payload,
      {
        permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.UPDATE_COUNTRY,
        urlParams: {
          id,
        },
      },
    ),
    onSuccess() {
      displayPresetToast('edited');
    },
  });
}
